import { render } from "./gf4satinfo.vue?vue&type=template&id=5e9cfcf5"
const script = {}

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__